import React, { useState } from "react";
import { PiArrowUpRight } from "react-icons/pi";
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/thumbs';



const PortfolioBox = ({ item }) => {
  const [isLinkHovered, setIsLinkHovered] = useState(false);
  const handleLinkMouseOver = () => {
    setIsLinkHovered(true);
  };

  const handleLinkMouseLeave = () => {
    setIsLinkHovered(false);
  };

  const [open, setOpen] = useState(false);
  const onOpenModal = () => setOpen(true);
  const onCloseModal = () => setOpen(false);


  return (
    <div className={`section sec${item.id} swiperWrap`} key={item.id} style={{ backgroundImage: `url(${item.main})` }} onWheel={(e) => {
      if (open) {
        e.stopPropagation();
        return;
      }
    }}>
      <div className="port-box">
        <div>
          <div className="d-inline-block">
            <div className={`port-line bg-${item.title_color}`} />
            <h2 className={`godo-b fs-50px fc-${item.title_color} mb-30px ${isLinkHovered ? 'hovered-link' : ''}`}
              onMouseOver={handleLinkMouseOver}
              onMouseLeave={handleLinkMouseLeave}
            >{item.title}</h2>
          </div>
          <div dangerouslySetInnerHTML={{ __html: item.subject }} className={`fs-26px mb-30px w-max-558px fc-${item.title_color} port-subject  ${isLinkHovered ? 'hovered-link' : ''}`}
            onMouseOver={handleLinkMouseOver}
            onMouseLeave={handleLinkMouseLeave}
          />

          <div className={`view-more-btn view-more-${item.title_color}  ${isLinkHovered ? 'hovered-link' : ''}`} onClick={onOpenModal} onMouseOver={handleLinkMouseOver}
            onMouseLeave={handleLinkMouseLeave}>
            <div className={`${item.title_color === "white" ? 'fc-black' : 'fc-white'}`} >상세보기</div>
            <PiArrowUpRight size={24} color={item.title_color === "white" ? '#000' : '#fff'} />
          </div>
        </div>
      </div>

      {item.detail && (
        <Modal open={open} onClose={onCloseModal} center >
          <div >
            <img src={item.detail} alt={item.title} className={`port-detail-img `} />
          </div>
        </Modal>
      )}

    </div>
  );
};

export default PortfolioBox;
